import type { DataTable } from '@/chart-data-processor/table-processor';
import type { ChartData } from './types';
import type { ChartDataOptionsInternal } from '@/chart-data-options/types';
import type { ChartType } from '@/types';

export type ChartDataHandler = (
  chartDataOptions: ChartDataOptionsInternal,
  dataTable: DataTable,
) => ChartData;

const chartDataHandlers = new Map<ChartType, ChartDataHandler>();

export const registerChartDataHandler = (
  chartType: ChartType,
  handler: ChartDataHandler,
) => {
  chartDataHandlers.set(chartType, handler);
};

export const getChartDataHandler = (chartType: ChartType) => {
  return chartDataHandlers.get(chartType);
};

export const clearChartDataHandlers = () => {
  chartDataHandlers.clear();
};
